module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-62.a265cc57.svg";